import React from "react";
import { CircularProgress, Backdrop } from "@mui/material";

const Loading = ({ isLoading = true }) => (
  <Backdrop
    open={isLoading}
    sx={{
      backgroundColor: "rgba(0, 0, 0, 0.1)",
      zIndex: 999,
    }}
  >
    <CircularProgress size={100} sx={{ color: "var(--color-gray-1)" }} />
  </Backdrop>
);

export default Loading;
